import { MenuType } from '../../constants/menu.constant';
import { Language } from '../../constants/ui-utils.constant';
import { LanguageLocal } from '../../enum/ui-utils.enum';
import { ProgramType, WebinarType } from '../../enum/webinar-course.enum';
import { ProgramTopicsListInterface } from '../../models/filter.model';

export interface RecursiveLinkInterface {
    children?: RecursiveLinkInterface[];
    cssClass?: string;
    icon?: string;
    id?: string;
    htmlId?: string;
    label: string;
    link?: string;
    param?: RecursiveLinkParamInterface;
    menuType?: MenuType;
}

export class RecursiveLinksModel {
    children?: RecursiveLinksModel[];
    cssClass?: string;
    icon?: string;
    id?: string;
    htmlId?: string;
    label: string;
    link?: string;
    param?: RecursiveLinkParamInterface;
    menuType?: MenuType;

    constructor(
        public model: ProgramTopicsListInterface,
        public currentLang: string,
    ) {
        this.id = model.id;
        this.label = model.name;
        this.param = { topic: model.id };
        this.link = this.getLink();
        this.menuType = MenuType.Topic;

        if (model.sub) {
            this.children = model.sub.map((child) => new RecursiveLinksModel(child, currentLang));
        }

        if (currentLang === LanguageLocal.LanguageCN) {
            this.label = model.translations?.find((t) => t.language === Language.CH)?.description || model.name;
        }
    }

    private getLink(): string {
        return '/program/list/course';
    }
}

export interface RecursiveLinkParamInterface {
    webinarType?: WebinarType;
    programType?: ProgramType;
    topic?: string;
}
